import { LogOut, Settings, User } from "lucide-react";
import type { FC } from "react";
import React from "react";

import { AppToolButton } from "@react/foundation/app";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@react/ui-primitives/dropdown-menu";

interface AppMenuProps {
  readonly isSignedIn: boolean;
  readonly onLogout: () => void;
}

export const AppMenu: FC<AppMenuProps> = ({ isSignedIn, onLogout }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <AppToolButton icon={User} />
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuLabel>My Account</DropdownMenuLabel>
      <DropdownMenuSeparator />
      <DropdownMenuItem>
        <User />
        Profile
      </DropdownMenuItem>
      <DropdownMenuItem>
        <Settings />
        Settings
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem
        disabled={!isSignedIn}
        onSelect={onLogout}
        variant="destructive"
      >
        <LogOut />
        Log out
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
